import { useState, useEffect } from 'react';
import FormGroup from "./FormGroup";
import ImagePreviewer from "./ImagePreviewer";

const ImageSelectorWithPreview = (props) => {
    const [previewUrl, setPreviewUrl] = useState(null);
    const [selectedFile, setSelectedFile] = useState(null);

    useEffect(() => {
        if (props.onLoad) {
            props.onLoad();
        }
    }, []);

    useEffect(() => {
        // Set preview URL from existing image (for editing)
        if (props.existingImageUrl) {
            setPreviewUrl(props.existingImageUrl);
        }
    }, [props.existingImageUrl, props.network]);

    const onChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setSelectedFile(file);
            
            // Create preview URL for new file
            const url = URL.createObjectURL(file);
            setPreviewUrl(url);
            
            // Call parent onChange with the file
            props.onChange(props.id, file);
        }
    };

    const clearImage = () => {
        setSelectedFile(null);
        setPreviewUrl(props.existingImageUrl || null);
        props.onChange(props.id, null);
    };

    return (
        <FormGroup {...props}>
            <div className="image-selector-container">
                {previewUrl && (
                    <div className="image-preview-container mb-3">
                        <div className="d-flex align-items-center">
                            <ImagePreviewer 
                                url={previewUrl} 
                                width={props.previewWidth || 150} 
                                height={props.previewHeight || 150}
                            />
                            <div className="ms-3">
                                <div className="mb-2">
                                    <strong>Current Image:</strong>
                                </div>
                                {props.existingImageUrl && !selectedFile && (
                                    <div>
                                        <a 
                                            href={props.existingImageUrl} 
                                            target="_blank" 
                                            rel="noopener noreferrer"
                                            className="btn btn-sm btn-outline-primary me-2"
                                        >
                                            View Full Size
                                        </a>
                                        <button 
                                            type="button"
                                            className="btn btn-sm btn-outline-danger"
                                            onClick={clearImage}
                                        >
                                            Remove Image
                                        </button>
                                    </div>
                                )}
                                {selectedFile && (
                                    <div>
                                        <small className="text-muted">
                                            New file: {selectedFile.name}
                                        </small>
                                        <br />
                                        <button 
                                            type="button"
                                            className="btn btn-sm btn-outline-secondary mt-1"
                                            onClick={clearImage}
                                        >
                                            Cancel Upload
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                )}
                
                <input 
                    required={props.required || false} 
                    className="form-control"
                    type="file"
                    name={props.id}
                    accept="image/*"
                    onChange={onChange}
                />
                
                {!previewUrl && (
                    <small className="text-muted">
                        No image selected. Choose an image file to upload.
                    </small>
                )}
            </div>
        </FormGroup>
    );
};

export default ImageSelectorWithPreview;
